module.exports = __webpack_public_path__ + "img/banner.35784d30.png";